import React from 'react';
import DashboardComponent from './DashboardComponent';

export default function DashboardContainer() {
  return <DashboardComponent />;
}
